import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./style.scss";

class Tab extends Component {
  getSize = (value) => {
    if (value > 9) {
      return "long";
    } else if (value < 3) {
      return "small";
    } else {
      return "medium";
    }
  };

  render() {
    return (
      <NavLink
        className={`tab-wrapper ${this.getSize(this.props.name.length)}`}
        name={this.props.name}
        to={this.props.path}
      >
        <div className="title">{this.props.name}</div>
      </NavLink>
    );
  }
}

export default Tab;
